import React, { createContext, useState } from "react";
import { enquiryType } from "venuescanner-js/constants/thread";

export const EnquiryContext = createContext({
  indicators: null,
  setIndicators: null,
  networks: null,
  setNetworks: null,
  venues: null,
  setVenues: null,
  users: null,
  setUsers: null,
  threads: null,
  setThreads: null,
  counts: null,
  setCounts: null,
  enquiriesLoading: null,
  setEnquiriesLoading: null,
  enquiriesAvailable: null,
  setEnquiriesAvailable: null,
  enquiryViewType: null,
  setEnquiryViewType: null,
  allLeads: null,
  setAllLeads: null,
  leadCounts: null,
  setLeadCounts: null,
  hostleads: null,
  setHostLeads: null,
  missedLeads: null,
  setMissedLeads: null,
  lockedVenues: null,
  setLockedVenues: null,
  organiserLeads: null,
  setOrganiserLeads: null,
});

const EnquiryProvider = ({ children }) => {
  const [indicators, setIndicators] = useState([]);
  const [networks, setNetworks] = useState([]);
  const [venues, setVenues] = useState([]);
  const [users, setUsers] = useState([]);
  const [threads, setThreads] = useState([]);
  const [counts, setCounts] = useState([]);
  const [enquiriesLoading, setEnquiriesLoading] = useState(true);
  const [enquiriesAvailable, setEnquiriesAvailable] = useState(false);
  const [enquiryViewType, setEnquiryViewType] = useState(enquiryType.THREAD);
  const [allLeads, setAllLeads] = useState([]);
  const [leadCounts, setLeadCounts] = useState({ leads: 0, matches: 0 });
  const [hostLeads, setHostLeads] = useState(null);
  const [missedLeads, setMissedLeads] = useState([]);
  const [lockedVenues, setLockedVenues] = useState([]);
  const [organiserLeads, setOrganiserLeads] = useState(null);

  return (
    <EnquiryContext.Provider
      value={{
        indicators,
        setIndicators,
        networks,
        setNetworks,
        venues,
        setVenues,
        users,
        setUsers,
        threads,
        setThreads,
        counts,
        setCounts,
        enquiriesLoading,
        setEnquiriesLoading,
        enquiriesAvailable,
        setEnquiriesAvailable,
        enquiryViewType,
        setEnquiryViewType,
        allLeads,
        setAllLeads,
        leadCounts,
        setLeadCounts,
        hostLeads,
        setHostLeads,
        missedLeads,
        setMissedLeads,
        lockedVenues,
        setLockedVenues,
        organiserLeads,
        setOrganiserLeads,
      }}
    >
      {children}
    </EnquiryContext.Provider>
  );
};

export default EnquiryProvider;
